import { ErrorCard } from '#/shared/components/ErrorCard';
import { Container } from '#/shared/components/layout/Container';

export function ApprovalSuccessScreen() {
  return (
    <Container className="flex flex-1 flex-col items-center justify-center space-y-4">
      <ErrorCard title="Thank you" description="This timesheet has been approved." />
    </Container>
  );
}
